
export const spliceString = ({ val, maxLength = 25 }) => {

    if(val.length <= maxLength) return val;

    return `${val.slice(0,maxLength)}...`
}

export const capitalizeString = ({ val }) => {

    let returnString = '';

    // check has white space
    if(val.indexOf(' ') >= 0){

        // split the above string into an array of strings 
        // whenever a blank space is encountered
    
        const arr = val.split(" ");
    
        // loop through each element of the array and capitalize the first letter.
    
    
        for (let i = 0; i < arr.length; i+=1) {
            arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    
        }
    
        // Join all the elements of the array back into a string 
        // using a blankspace as a separator 
        returnString = arr.join(" ");

    }else{

        returnString = val.charAt(0).toUpperCase() + val.slice(1);

    }

    
    return returnString

}